
import Vue from 'vue'
import { PageThemeCustomization, ClientPageConfigFooter } from '@/types'

export enum PhoneConfigType {
  EMPTY = 'EMPTY',
  STORE = 'STORE',
  EXCHANGE_PLACE = 'EXCHANGE_PLACE',
  CUSTOM = 'CUSTOM',
}

export default Vue.extend({
  name: 'fo-footer',
  props: {
    hasStickyBtn: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object as () => ClientPageConfigFooter,
      required: true,
    },
    theme: {
      type: Object as () => PageThemeCustomization,
      required: false,
      default: () => ({
        backgroundColor: '#FFFFFF',
      }),
    },
    dataId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    phone: false as boolean | string,
    url: '',
    legal: '',
  }),
  computed: {
    cssGetBackgroundColor() {
      return {
        '--footer-bg-color': this.theme.backgroundColor ?? '#FFFFFF',
      }
    },
    footerClasses(): string {
      if (this.$vuetify.breakpoint.smAndUp) {
        return 'd-flex flex-column'
      } else if (this.$vuetify.breakpoint.xsOnly && this.hasStickyBtn) {
        return 'more-padding'
      }

      return ''
    },
  },
  async mounted() {
    this.updateDataFromConfig(this.config)
  },
  methods: {
    updateDataFromConfig(config: ClientPageConfigFooter) {
      const {
        phone: { type, number: phoneNumber = '' },
        customerServiceUrl,
        legalNotice,
      } = config

      this.url = customerServiceUrl || ''
      this.legal = legalNotice || ''

      // Configure phone number
      switch (type) {
        case PhoneConfigType.CUSTOM:
        case PhoneConfigType.STORE:
        case PhoneConfigType.EXCHANGE_PLACE:
          this.phone = phoneNumber
          break
        case PhoneConfigType.EMPTY:
          this.phone = ''
          break
        default:
          break
      }
    },
  },
  watch: {
    config(next) {
      this.updateDataFromConfig(next)
    },
  },
})
